import { updateResultPageTab, updatePage } from "../../../features/pageManager/pageManagerSlice";
import { ResultTabKey, PageKey } from "../../../features/pageManager/pageState";
import { AppDispatch } from "../../../store";

export const openResult = (dispatch: AppDispatch) => {
    dispatch(updateResultPageTab(ResultTabKey.CurrentMesasurement));
    dispatch(updatePage(PageKey.Result));
  }

